import React, {Component} from 'react';
import { connect } from 'react-redux';

import { t } from 'l10n';

import Loading from 'components/Loading';
import MessageList from 'components/message/MessageList';
import MessageHeader from 'components/message/MessageHeader';

import {
    getMemberMessageList,
    clearMessageListInMemory
} from 'reducers/memberMessageList';

class MessageListMessages extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pendingScroll: false,
            showTopButton: false,
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    fetchData(params) {
        return getMemberMessageList({...params});
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(this.fetchData());

        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        let action = clearMessageListInMemory();
        dispatch(action);

        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(e) {
        const {
            scrollTop,
            scrollHeight,
            clientHeight,
        } = e.target.scrollingElement;
        let innerHeight = window.innerHeight;
        const bottom = scrollTop + innerHeight == scrollHeight;

        const {
            offset,
            totalCount
        } = this.props.memberMessageList;

        this.setState({showTopButton: scrollTop !== 0})

        if(scrollTop !== 0 && bottom && offset !== totalCount) {
            const { dispatch, location } = this.props;

            const params = {
                offset: offset
            };

            this.setState({pendingScroll: true})

            let action = this.fetchData(params);
            dispatch(action);
                    
            action.promise
                .then(() => {
                    this.setState({pendingScroll: false})
                })
                .catch((e) => this.setState({pendingScroll: false}));
        }
    }

    render() {      
        const { 
            newCount,
            totalCount,
            trashCount,
            messageList
        } = this.props.memberMessageList;

        const {
            pendingScroll,
            showTopButton,
        } = this.state;

        if(!messageList) return <Loading centered/>;

        return (
            <div className="member-message">
                <MessageHeader
                    newCount={newCount}
                    trashCount={trashCount}
                    messagesCount={totalCount}
                    showForm={true}
                    title={t('My messages')}
                />
                <MessageList 
                    messageList={messageList} 
                    showTopButton={showTopButton && totalCount !== 0}
                />
                {pendingScroll ? <Loading /> : null}
            </div>
        )
    }
}

export default connect(
    state => ({
        memberMessageList: state.memberMessageList
    }),
    null
)(MessageListMessages)


// WEBPACK FOOTER //
// ./src/containers/member/MessageListMessages.js